import dayjs from 'dayjs';
import { DataRow } from 'plume-ui/dist/components/Table/Table';
import { STANDARD_DATE_TIME_FORMAT } from '../../../../config';
import { WebhookStatus } from './types';

export const mapWebhookStatusToColor = (status: string) =>
  status === 'failed' ? '#FA1478' : '#17E3AE';

export const parseWebhookToDataRows = (data: WebhookStatus[]): DataRow[] => {
  return data.map((row) => {
    let lastError, lastSuccess;
    if (row.lastError === null || row.lastError === undefined) {
      lastError = '';
    } else {
      lastError = dayjs
        .utc(row.lastError)
        .local()
        .format(STANDARD_DATE_TIME_FORMAT);
    }
    if (row.lastSuccess === null || row.lastSuccess === undefined) {
      lastSuccess = '';
    } else {
      lastSuccess = dayjs
        .utc(row.lastSuccess)
        .local()
        .format(STANDARD_DATE_TIME_FORMAT);
    }
    return {
      name: row.name,
      platformUrl: row.urlEndpoint,
      credentials: row.status,
      lastError,
      lastSuccess,
      noOfSupportOutreach: `${row.outreachId?.length}`,
      action: row.id,
      enabled: `${row.enabled}`,
    };
  });
};
